import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import { getAdminProductTypes, getAdminBrands, addAdminBrand, updateAdminBrand, deleteAdminBrand } from '../api/adminApi';

export const AdminBrands = () => {
  const { token } = useAdminAuth();
  const [types, setTypes] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [nameInput, setNameInput] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  useEffect(() => {
    async function loadTypes() {
      const result = await getAdminProductTypes(token);
      if (result.success) setTypes(result.data.productTypes);
    }
    loadTypes();
    // eslint-disable-next-line
  }, []);

  const loadBrands = async (typeId) => {
    if (!typeId) {
      setBrands([]);
      return;
    }
    setLoading(true);
    const result = await getAdminBrands(token, typeId);
    setLoading(false);
    if (result.success) {
      setBrands(result.data.brands);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const handleTypeChange = (e) => {
    const typeId = e.target.value;
    setSelectedType(typeId);
    loadBrands(typeId);
  };

  const openAddModal = () => {
    if (!selectedType) {
      setToast({ show: true, type: 'error', message: 'ابتدا یک نوع محصول انتخاب کنید.' });
      return;
    }
    setEditingId(null);
    setNameInput('');
    setShowModal(true);
  };

  const openEditModal = (brand) => {
    setEditingId(brand.id);
    setNameInput(brand.name);
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!nameInput.trim()) return;

    const result = editingId
      ? await updateAdminBrand(token, editingId, nameInput)
      : await addAdminBrand(token, selectedType, nameInput);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      setShowModal(false);
      loadBrands(selectedType);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const handleDelete = async () => {
    if (!deleteTarget) return;
    const result = await deleteAdminBrand(token, deleteTarget.id);
    setDeleteTarget(null);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadBrands(selectedType);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  return (
    <div dir="rtl" style={{ padding: 24 }}>
      <h2 className="w3-text-white" style={{ marginBottom: 20 }}>مدیریت برندها</h2>

      <div style={{ display: 'flex', gap: 14, marginBottom: 20, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div style={{ minWidth: 240 }}>
          <label className="w3-text-white">نوع محصول</label>
          <select
            value={selectedType}
            onChange={handleTypeChange}
            className="w3-select"
            style={{ border: '1px solid white', backgroundColor: '#263238', color: 'white', borderRadius: 8, height: 40, padding: '0 10px' }}
          >
            <option value="">انتخاب کنید...</option>
            {types.map((t) => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>

        <button
          onClick={openAddModal}
          className="w3-button w3-round-xxlarge"
          style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', display: 'flex', alignItems: 'center', height: 40 }}
        >
          <i className="material-icons w3-margin-left">add</i>
          افزودن برند
        </button>
      </div>

      <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238', padding: 10 }}>
        {!selectedType ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>یک نوع محصول انتخاب کنید.</p>
        ) : loading ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>در حال بارگذاری...</p>
        ) : brands.length === 0 ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>برندی برای این نوع محصول ثبت نشده است.</p>
        ) : (
          <table className="w3-table w3-text-white" style={{ width: '100%' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #37474F' }}>
                <th style={{ textAlign: 'right', padding: 10 }}>#</th>
                <th style={{ textAlign: 'right', padding: 10 }}>نام برند</th>
                <th style={{ textAlign: 'left', padding: 10 }}>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {brands.map((brand) => (
                <tr key={brand.id} style={{ borderBottom: '1px solid #263238' }}>
                  <td style={{ padding: 10 }}>{brand.id}</td>
                  <td style={{ padding: 10 }}>{brand.name}</td>
                  <td style={{ padding: 10, textAlign: 'left' }}>
                    <button onClick={() => openEditModal(brand)} className="w3-button" style={{ color: '#4FC3F7' }}>
                      <i className="material-icons">edit</i>
                    </button>
                    <button onClick={() => setDeleteTarget(brand)} className="w3-button" style={{ color: '#ff0000' }}>
                      <i className="material-icons">delete</i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 360, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ borderBottom: '1px solid #37474F' }}>
              <span onClick={() => setShowModal(false)} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{editingId ? 'ویرایش برند' : 'افزودن برند'}</h4>
            </div>
            <div className="w3-container w3-padding">
              <label className="w3-text-white">نام برند</label>
              <input
                type="text"
                value={nameInput}
                onChange={(e) => setNameInput(e.target.value)}
                className="w3-input"
                style={{ border: '1px solid white', backgroundColor: 'transparent', color: 'white', borderRadius: 8, height: 40 }}
              />
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button onClick={handleSave} className="w3-button w3-block" style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 10 }}>
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteTarget && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 340, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
              <h4 className="w3-text-white" style={{ margin: 0 }}>تایید حذف</h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">آیا از حذف برند «{deleteTarget.name}» مطمئن هستید؟ فایل‌های این برند نیز حذف خواهند شد.</p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16, display: 'flex', gap: 10 }}>
              <button onClick={handleDelete} className="w3-button" style={{ flex: 1, color: 'white', backgroundColor: '#ff0000', borderRadius: 10 }}>
                بله، حذف شود
              </button>
              <button onClick={() => setDeleteTarget(null)} className="w3-button" style={{ flex: 1, color: '#15ff00', border: '2px solid #15ff00', backgroundColor: 'transparent', borderRadius: 10 }}>
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {toast.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 320, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: toast.type === 'success' ? '#15ff0022' : '#ff000022', borderBottom: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}` }}>
              <span onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{toast.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{toast.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-block" style={{ color: toast.type === 'success' ? '#15ff00' : '#ff0000', border: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`, backgroundColor: 'transparent', borderRadius: 10 }}>
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};